// Generated by purs version 0.13.0
"use strict";
var keyup = "keyup";
var keydown = "keydown";
module.exports = {
    keydown: keydown,
    keyup: keyup
};
